import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';



const EditLeadSource = ({ show, onClose, leadsourceIdToEdit, refresh }) => {
    const [leadsource_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingLeadsource, setExistingLeadsource] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const formatleadsourceName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    useEffect(() => {
        if (show && leadsourceIdToEdit) {
            axios.get(`${baseURL}/leadsource/${leadsourceIdToEdit}`)
                .then(response => {
                    console.log("Fetched leadsource:", response.data);
                    console.log("Fetched leadsource:", response.data);
                    const leadsource = response.data.data;
                    setname(leadsource.leadsource_name);
                    setDescription(leadsource.description || '');
                })
                .catch(error => {
                    console.error("Error fetching leadsource", error);
                });

                axios.get(`${baseURL}/leadsource`)
                    .then(response => {
                        setExistingLeadsource(
                            response.data.data.data
                                .filter(c => c.sno !== leadsourceIdToEdit) // exclude current one
                                .map(leadsource => leadsource.leadsource_name.toLowerCase())
                        );
                    })
                    .catch(error => {
                        console.error("Error fetching countries", error);
                    });
            }
        }, [show, leadsourceIdToEdit]);

        const validateInput = () => {
            // Check if the Leadsource name is empty
            if (!leadsource_name.trim()) {
                setError("Leadsource is required.");
                return false;
            }
            
            const regex = /^[A-Za-z\s]+$/;
            if (!regex.test(leadsource_name)) {
                setError("Only text is valid.");
                return false;
            }
            
            const formattedleadsourceName = leadsource_name.trim().toLowerCase();
            // Check if the Leadsource already exists
            if (existingLeadsource.includes(leadsource_name.trim().toLowerCase())) {
                setError("Leadsource already exists.");
                return false;
            }
    
            setError('');
            return true;
        };

        const handleUpdate = (e) => {
                e.preventDefault();
        
                const formattedleadsourceName = formatleadsourceName(leadsource_name);
        
                if (!validateInput()) return;
        
                axios.put(`${baseURL}/leadsource/${leadsourceIdToEdit}`, {
                    leadsource_name,
                    description
                })
                    .then(response => {
                        refresh();
                        onClose();
                        toast.success("Lead Source Updated successfully!");
                        // window.location.reload(); // optional, can use state update instead
                    })
                    .catch(error => {
                        console.error("Error updating Lead source", error);
                        setError("An error occurred while updating the Lead source.");
                    });
            };

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Lead Source</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleUpdate}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Lead Source<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Source" 
                            value={leadsource_name}
                            onChange={(e) => setname(formatleadsourceName(e.target.value))}/>
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control h-auto" name="comment" placeholder="Description" 
                            value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary">Update Lead Source<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditLeadSource;
